export const CATALOGO_BASELINE_CARD_WIDTH_PX = 420;
export const CATALOGO_TARGET_CARD_MAX_WIDTH_PX = 240;

// SPEC-036: ancho mínimo de columna para el grid auto-fill de productos.
// Elegido para preservar ≥3 columnas en desktop estándar (1366px) — RN-05.
export const CATALOGO_PRODUCT_MIN_COL_WIDTH_PX = 200;

export function getCatalogoGridColumns(viewportWidth: number): number {
  if (viewportWidth >= 1600) return 4;
  if (viewportWidth >= 1366) return 3;
  if (viewportWidth >= 900) return 2;
  return 1;
}

export function isCardWidthReductionCompliant(
  baselineWidthPx: number,
  targetWidthPx: number,
  requiredReductionRatio = 0.4
): boolean {
  if (baselineWidthPx <= 0 || targetWidthPx <= 0) {
    return false;
  }

  const ratio = 1 - targetWidthPx / baselineWidthPx;
  return ratio >= requiredReductionRatio;
}
